// extracted by mini-css-extract-plugin
module.exports = {"usersBlock":"Users_usersBlock__6uziw","bg":"Users_bg__3I9hH","bgTitle":"Users_bgTitle__1rFBv","usersContainer":"Users_usersContainer__19ZyT"};